/**
 * Vet auto free gift: add to cart, remove from cart, discount redirect.
 * Web component <vet-auto-gift>. Config from child or document:
 *   <script type="application/json" data-vet-auto-gift-config>...</script>
 * Only runs when document.body has class .vet-portal-body.
 */
(function () {
  function getConfigFromScript(script) {
    if (!script?.textContent) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function updateCartBubble(cart) {
    if (typeof window.applyCartBubbleCountFromCart === 'function' && cart && typeof cart.item_count === 'number') {
      window.applyCartBubbleCountFromCart(cart);
      return;
    }
    const count =
      typeof window.getCartBubbleDisplayCount === 'function'
        ? window.getCartBubbleDisplayCount(cart)
        : cart && typeof cart.item_count === 'number'
          ? cart.item_count
          : 0;
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    const countBubble = bubble.querySelector('.cart-count-bubble');
    if (countBubble) {
      const span = countBubble.querySelector('span[aria-hidden="true"]');
      if (span) span.textContent = count;
    } else if (count > 0) {
      const container = bubble.querySelector('.header-vet__cart-icon-container');
      if (container) {
        const newBubble = document.createElement('div');
        newBubble.className = 'cart-count-bubble';
        newBubble.innerHTML = `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count === 1 ? '1 item' : `${count} items`} in cart</span>`;
        container.appendChild(newBubble);
      }
    }
  }

  function runAutoAdd(config) {
    if (!config?.variantId) return;
    const variantId = config.variantId;
    const variantIdNum = parseInt(String(variantId), 10);
    if (!Number.isFinite(variantIdNum)) return;
    const discountCode = config.discountCode ?? null;
    const root = window.Shopify?.routes?.root ?? '/';

    window
      .cartFetchWithRetry(`${root}cart.js`)
      .then((r) => {
        if (!r.ok) throw new Error(`Cart read failed (${r.status})`);
        return r.json();
      })
      .then((cart) => {
        const hasVariant =
          (cart.items || []).some((item) => String(item.variant_id) === String(variantId));
        if (hasVariant) return null;
        return window.cartFetchWithRetry(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantIdNum,
                quantity: 1,
                properties: { _vet_auto_free_gift: 'true' },
              },
            ],
            sections: 'cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        }).then((res) => {
          // 422 carries a valid JSON body describing why the gift could not be added.
          if (!res.ok && res.status !== 422) throw new Error(`Cart add failed (${res.status})`);
          return res.json();
        });
      })
      .then((data) => {
        if (
          data &&
          !data.status &&
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vet-auto-free-gift',
            cartData: data,
          });
        }
        if (!data || data.status) return;
        if (typeof data.item_count === 'number') {
          updateCartBubble(data);
        } else {
          const cartUrl = window.routes?.cart_url
            ? window.routes.cart_url.replace(/\/?$/, '') + '.js'
            : `${root}cart.js`;
          fetch(cartUrl)
            .then((r) => r.json())
            .then((cart) => updateCartBubble(cart))
            .catch(() => {});
        }
        if (discountCode?.length > 0) {
          window.vetAutoFreeGiftDiscountCode = discountCode;
          const redirectPath = root.replace(/\/?$/, '') || '/';
          window.location.href = `${root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(redirectPath)}`;
        }
      })
      .catch(() => {});
  }

  function runRemove() {
    const root = window.Shopify?.routes?.root ?? '/';

    fetch(`${root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const toRemove = (cart.items || []).filter(
          (item) => item.properties?._vet_auto_free_gift === 'true'
        );
        if (toRemove.length === 0) return null;
        return toRemove
          .reduce(
            (p, item) =>
              p.then(() =>
                fetch(`${root}cart/change.js`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                  },
                  body: JSON.stringify({ id: item.key, quantity: 0 }),
                }).then((res) => res.json())
              ),
            Promise.resolve()
          )
          .then(() => fetch(`${root}cart.js`).then((r) => r.json()));
      })
      .then((updatedCart) => {
        if (!updatedCart) return;
        if (
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined'
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vet-auto-free-gift-removed',
            cartData: updatedCart,
          });
        }
        updateCartBubble(updatedCart);
      })
      .catch(() => {});
  }

  function runDiscountRedirect(code) {
    if (!code) return;
    window.vetAutoFreeGiftDiscountCode = code;
    const form = document.getElementById('CartDrawer-Form');
    if (!form) return;
    form.addEventListener(
      'submit',
      (e) => {
        if (!window.vetAutoFreeGiftDiscountCode) return;
        let hasVetAutoGift = false;
        try {
          hasVetAutoGift = document.querySelector('[data-vet-auto-free-gift-line]') !== null;
        } catch {}
        if (!hasVetAutoGift) return;
        e.preventDefault();
        e.stopPropagation();
        const root = window.Shopify?.routes?.root ?? '/';
        const checkoutPath = `${root}checkout`.replace(/\/$/, '');
        window.location.href = `${root}discount/${encodeURIComponent(window.vetAutoFreeGiftDiscountCode)}?redirect=${encodeURIComponent(checkoutPath)}`;
      },
      true
    );
  }

  class VetAutoGift extends HTMLElement {
    getConfig() {
      const script =
        this.querySelector('script[data-vet-auto-gift-config]') ||
        document.querySelector('script[data-vet-auto-gift-config]');
      return getConfigFromScript(script);
    }

    connectedCallback() {
      if (!document.body.classList.contains('vet-portal-body')) return;
      const config = this.getConfig();
      if (!config) return;

      if (config.autoAdd) {
        runAutoAdd(config.autoAdd);
      }
      if (config.removeAutoGift) {
        runRemove();
      }
      if (config.discountCode) {
        runDiscountRedirect(config.discountCode);
      }
    }
  }

  if (typeof customElements !== 'undefined' && !customElements.get('vet-auto-gift')) {
    customElements.define('vet-auto-gift', VetAutoGift);
  }
})();
